module.exports = __webpack_public_path__ + "static/img/2.5a26161c.jpg";